import { BillingBucketDTO } from "../DTO/billingBucketDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateBillingBucketRequest extends BasicRequest{
    public billingBucket!:BillingBucketDTO;
}